export const LOGIN_USER = 'LOGIN_USER'
export const LOGIN_USER_action = (data) => {
    return {
        type: LOGIN_USER,
        info: data
    }
}

export const REGISTER_USER = 'REGISTER_USER'
export const REGISTER_USER_action = (data) => {
    return {
        type: REGISTER_USER,
        info: data
    }
}